var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { TextButtonStructure } from '../components/TextButtonStructure';
import { Label } from '../../Label';
// Styles
import { getTextButtonStylesBySize } from './getTextButtonStylesBySize';
import { getTextButtonStylesByIcon } from './getTextButtonStylesByIcon';
import { getTextButtonStylesByVariant } from './getTextButtonStylesByVariant';
// Utils
import styled from 'styled-components';
export var StyledTextButton = styled(TextButtonStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  grid-template-columns: repeat(2, max-content);\n  align-items: center;\n  border: none;\n  padding: 0;\n\n  ", " {\n    word-break: break-word;\n  }\n\n  ", "\n  ", ";\n  ", ";\n"], ["\n  grid-template-columns: repeat(2, max-content);\n  align-items: center;\n  border: none;\n  padding: 0;\n\n  ", " {\n    word-break: break-word;\n  }\n\n  ", "\n  ", ";\n  ", ";\n"])), Label, function (_a) {
    var size = _a.size;
    return getTextButtonStylesBySize(size);
}, function (_a) {
    var icon = _a.icon, isIconOnRight = _a.isIconOnRight;
    return getTextButtonStylesByIcon(icon, isIconOnRight);
}, function (_a) {
    var disabled = _a.disabled, styleVariant = _a.styleVariant, theme = _a.theme;
    return getTextButtonStylesByVariant(disabled, styleVariant, theme);
});
var templateObject_1;
//# sourceMappingURL=StyledTextButton.js.map